import '@yaireo/tagify/dist/tagify.polyfills.min.js';

/* eslint-disable */
import React, {
    useState,
    useRef,
    Fragment,
    useEffect,
    useCallback,
} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// React-wrapper file
import Tags from '@yaireo/tagify/dist/react.tagify';
// Tagify CSS
import '@yaireo/tagify/dist/tagify.css';

const InputContainerWrapper = styled.div`
    position: relative;
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const tagifyCallbacks = {
    // add: callback,
    // remove: callback,
    // input: callback,
    // edit: callback,
    // invalid: callback,
    // click: callback,
    // keydown: callback,
    // focus: callback,
    // blur: callback,
    // "edit:input": callback,
    // "edit:updated": callback,
    // "edit:start": callback,
    // "edit:keydown": callback,
    // "dropdown:show": callback,
    // "dropdown:hide": callback,
    // "dropdown:select": callback
};

const baseTagifySettings = {
    blacklist: ['xxx', 'yyy', 'zzz'],
    maxTags: 100,
    dropdown: {
        enabled: 1,
    },
};

const InputTags = ({
    id,
    name,
    ref,
    placeholder,
    wrapperClass,
    input,
    readOnly,
    disabled,
    settings,
    tagifyProps,
    handleInputChange,
    handleInputBlur,
    handleInputFocus,
}) => {
    return (
        <Tags
            id={id}
            disabled={disabled}
            name={name}
            placeholder={placeholder}
            readOnly={readOnly}
            className={wrapperClass}
            tagifyRef={ref}
            settings={settings}
            value={input && input.value}
            {...tagifyProps}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onFocus={handleInputFocus}
        />
    );
};

const Input = props => {
    const {
        id,
        name,
        placeholder,
        wrapperClass,
        error,
        input,
        handleChange,
        handleBlur,
        handleFocus,
        readOnly,
        disabled = false,
        meta,
    } = props;

    const tagifyRef = useRef();
    const [tagifySettings, setTagifySettings] = useState([]);
    const [tagifyProps, setTagifyProps] = useState({});
    const settings = {
        ...baseTagifySettings,
        ...tagifySettings,
        callbacks: tagifyCallbacks,
    };

    function handleInputChange(event) {
        const formFieldChangeMethod =
            input && input.onChange
                ? input.onChange
                : handleChange
                ? handleChange
                : null;

        formFieldChangeMethod
            ? formFieldChangeMethod(event.target.value, event)
            : '';
    }

    function handleInputBlur() {
        input && input.onBlur ? input.onBlur() : '';
        handleBlur && handleBlur();
    }

    function handleInputFocus() {
        handleFocus && handleFocus();
    }

    const inputComponent = (
        <InputTags
            name={name}
            id={id}
            placeholder={placeholder}
            input={input}
            wrapperClass={wrapperClass}
            handleInputChange={handleInputChange}
            handleInputBlur={handleInputBlur}
            handleInputFocus={handleInputFocus}
            value={input && input.value}
            disabled={disabled}
            readOnly={readOnly}
            settings={settings}
            tagifyProps={tagifyProps}
            ref={tagifyRef}
        />
    );

    return (
        <InputContainerWrapper
            className={`input-container ${wrapperClass || ''}${
                error || (meta && meta.error && meta.touched) ? ' error' : ''
            }`}
        >
            <Fragment>{inputComponent}</Fragment>
            {meta && meta.touched && meta.error && (
                <ErrorWrapper className="error-message">
                    {meta.error}
                </ErrorWrapper>
            )}
        </InputContainerWrapper>
    );
};

Input.propTypes = {
    className: PropTypes.string,
    defaultSelected: PropTypes.string,
    handleChange: PropTypes.func,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    wrapperClass: PropTypes.string,
};

export default Input;
